import {
    FetchState,
    HsaStoreInfoState
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import { defineStore } from "pinia";
import _ from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";

export const initialState: HsaStoreInfoState = {
    status: FetchState.Uninitialized,
    hsaStoreInfos: []
};
export const useHsaStoreInfoStore = defineStore("hsaStoreInfo", {
    state: (): HsaStoreInfoState => (_.cloneDeep(initialState)),
    getters: {
        getHsaStoreInfos: state => state.hsaStoreInfos,
        isStoresLoaded: state => state.status === FetchState.Loaded
    },
    actions: {
        setHsaStoreInfos (hsaStoreInfos) {
            this.hsaStoreInfos = hsaStoreInfos;
            this.status = FetchState.Loaded;
        },
        setStatus (fetchState) {
            this.status = fetchState;
        },
        getHsaStoreInfosFromApi (partnerId, employerId): Promise<void>  {
            if (this.status === FetchState.Loaded) {
                return;
            }
            this.setStatus(FetchState.Loading);
            const notifierStore = useNotifierStore();

            UserService.getHsaStoreInfos (partnerId, employerId).then(response => {
                this.setHsaStoreInfos(response.data);
            }).catch(err => {
                this.setStatus(FetchState.Uninitialized);
                notifierStore.setDanger("Error loading hsa store info list");
            });
        }
    }
});
